import type { ActionResultSuccess, ActionResultFailure } from "@kestrel/actions";
import type {
  OnNavigateCallback,
  BeforeNavigateCallback,
  AfterNavigateCallback,
} from "@kestrel/navigator";
import type { KestrelStores } from "@kestrel/stores";
import { slashTrimEnd } from "@otto-ec/assets-core-utils/url";
import { logger } from "@otto-ec/global-resources/debug";
import { fetchRequest, handleError } from "../stores";
import { withHistory, withResolvers } from "./utils";

const log = logger("kestrel:ssr:navigator");

export const onNavigateHooks = new Set<OnNavigateCallback>();
export const beforeNavigateHooks = new Set<BeforeNavigateCallback>();
export const afterNavigateHooks = new Set<AfterNavigateCallback>();

/**
 *
 *
 *
 *
 *
 *
 *
 */
export async function navigate(
  stores: KestrelStores,
  baseUrl: URL,
  href: URL | string,
  type: NavigationType,
): Promise<(ActionResultSuccess | ActionResultFailure)["data"] | boolean> {
  const url = new URL(href, baseUrl);
  const { error, navigate: navStore } = stores;

  if (!slashTrimEnd(url.href).startsWith(slashTrimEnd(baseUrl.href))) {
    log.info("Invalid href:", url.href, "does not start with base:", baseUrl.href);
    return false;
  }

  const [complete, resolveComplete] = withResolvers();

  try {
    /*                           */
    let cancelled = false;
    await Promise.all(
      [...beforeNavigateHooks.values()].map((hook) =>
        hook({
          url,
          type,
          cancel: () => {
            cancelled = true;
          },
        }),
      ),
    );

    /*                                                                   */
    if (cancelled) return false;

    /*                                */
    const result = await fetchRequest(url);

    if (result.type === "error") {
      error.set(result.error);
      return true;
    }

    if (result.type === "redirect") {
      withHistory(result.location, navigate(stores, baseUrl, result.location, "push"));
      return false;
    }

    /*                                       */
    await Promise.all(
      [...onNavigateHooks.values()].map((hook) =>
        hook({ complete, to: url, from: new URL(window.location.href), type }),
      ),
    );

    /*                                                               */
    error.set(null);
    const { data } = result;
    /*                                             */
    navStore.set([data.routeId, data.routePath, data.data, undefined, resolveComplete]);
    /*                                          */
    await complete;

    /*                                                   */
    await Promise.all([...afterNavigateHooks.values()].map((hook) => hook({})));
    return data;
  } catch (e) {
    resolveComplete(); /*                                                           */
    handleError(e, error);
    return true;
  }
}
